import * as React from "react";
const EditIcon = ({
  height = 48,
  width = 48,
  color = "black",
  onClick = () => {},
  ...props
}) => (
  <svg
    onClick={onClick}
    cursor="pointer"
    width={width}
    height={height}
    viewBox="0 0 48 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 20C0 8.95431 8.9543 0 20 0H28C39.0457 0 48 8.95431 48 20C48 31.0457 39.0457 40 28 40H20C8.95431 40 0 31.0457 0 20Z"
      fill="white"
      fillOpacity={0.01}
    />
    <path
      d="M24 23H21V20L30 11L33 14L24 23Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.75 13.25L30.75 16.25"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.25 20V27.5C32.25 27.6989 32.171 27.8897 32.0303 28.0303C31.8897 28.171 31.6989 28.25 31.5 28.25H16.5C16.3011 28.25 16.1103 28.171 15.9697 28.0303C15.829 27.8897 15.75 27.6989 15.75 27.5V12.5C15.75 12.3011 15.829 12.1103 15.9697 11.9697C16.1103 11.829 16.3011 11.75 16.5 11.75H24"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default EditIcon;
